import { makeActionCreator } from '../../../utilities'
import { ZollSupportTicketConstants } from './zollSupportTicket.constants'

export const createZollSupportTicket = makeActionCreator(ZollSupportTicketConstants.CREATE_ZOLL_SUPPORT_TICKET)
export const setEmailAddress = makeActionCreator(ZollSupportTicketConstants.SET_EMAIL_ADDRESS, 'emailAddress')
export const setPhoneNumber = makeActionCreator(ZollSupportTicketConstants.SET_PHONE_NUMBER, 'phoneNumber')
export const setPreferredContactMethod = makeActionCreator(
  ZollSupportTicketConstants.SET_PREFERRED_CONTACT_METHOD,
  'preferredContactMethod'
)
export const setQuestionOrProblem = makeActionCreator(
  ZollSupportTicketConstants.SET_QUESTION_OR_PROBLEM,
  'questionOrProblem'
)
export const setShowModal = makeActionCreator(ZollSupportTicketConstants.SET_SHOW_MODAL, 'showModal')
export const setIsLoading = makeActionCreator(ZollSupportTicketConstants.SET_IS_LOADING, 'isLoading')
export const setTicketId = makeActionCreator(ZollSupportTicketConstants.SET_TICKET_ID, 'ticketId')
